import React, { ReactElement } from "react";

import Checkbox from "../../../../components/forms/Checkbox";
import {
  usePromptConfigEditorOps,
  usePromptConfigEditorState,
} from "../PromptConfigEditor";

export default function ForbidAnswerChange(): ReactElement {
  const prompt = usePromptConfigEditorState();
  const { updateFields } = usePromptConfigEditorOps();
  return (
    <Checkbox
      label="Forbid answer change"
      checked={prompt.definition.forbidsAnswerAlteration ?? false}
      onChange={(event) =>
        updateFields({ forbidsAnswerAlteration: event.target.checked })
      }
    />
  );
}
